import { request } from '@/utils/request';

/**
 * 加载独立站卖家信息
 * 对应老项目 uni.$api.base.loadSellerInfo
 */
export function loadSellerInfo() {
  return request<API.SellerInfoResponse>({
    url: '/newapi/seller/seller/getSellerSiteInfo',
    method: 'POST',
    data: {},
  });
}

/**
 * 加载店铺联系方式
 * 对应老项目 uni.$api.shop.loadShopContact
 */
export function loadShopContact(params: { sellerId: number }) {
  return request<API.ShopContactResponse>({
    url: '/newapi/seller/seller/getSellerContact',
    method: 'POST',
    data: params,
  }, {
    encrypt: true,
  });
}
